import {
  useLocation,
  useNavigate,
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import { useEffect } from 'react'
import { useLoggedInUser } from './@biz_account/useLoggedInUser/useLoggedInUser'
import { HealtCheckPage } from './@dev/sentry/HealtCheckPage'
import { NotFoundPage } from './@biz_helpers/not-found/NotFoundPage'
import { AccountRoutes } from './@routes/AccountRoutes/AccountRoutes'
import { InvestorRoutes } from './@routes/InvestorRoutes/InvestorRoutes'
import { OwnerRoutes } from './@routes/OwnerRoutes/OwnerRoutes'

export type IdentityPageProps = {
  prevPage?: string
  nextPage: string
  progressBar: number[]
}

const Router = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const { hasAuthToken, checkLoggedInUser, clearLoggedInUser } =
    useLoggedInUser()

  useEffect(() => {
    const loadUserOrNavigateToLogin = async () => {
      if (hasAuthToken()) {
        const userResponse = await checkLoggedInUser()

        if (
          !userResponse ||
          !('success' in userResponse) ||
          !userResponse.success
        ) {
          clearLoggedInUser()
          navigate('/')
          return
        }
      }
    }

    loadUserOrNavigateToLogin()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Routes location={location}>
      <Route path="/" element={<Navigate to="/account" replace />} />
      <Route path="/account">{AccountRoutes()}</Route>

      <Route path="/investor">{InvestorRoutes()}</Route>
      <Route path="/vlastnik">{OwnerRoutes()}</Route>

      <Route path="/dev/healt-check" element={<HealtCheckPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <Router />
    </BrowserRouter>
  )
}
